<template>
<div class="main-container">

    <Row>

      <Col span="6">
        <div class="message-menu">

          <Menu @on-select="changeView" style="width:100%" active-name="new">
            <Menu-group title="接收">
              <Menu-item name="new" @click="changeView('new')">
                <Icon type="email-unread"></Icon> 未读消息
                <Badge :count="this.$store.getters.messageNum" :overflow-count="99"></Badge>
              </Menu-item>
              <Menu-item name="read" @click="changeView('read')">
                <Icon type="email"></Icon> 已读消息
              </Menu-item>
                <Menu-item name="delete" @click="changeView('delete')">
                  <Icon type="trash-a"></Icon> 已删消息
                </Menu-item>
            </Menu-group>
            <Menu-group title="发送">
              <Menu-item name="add" @click="changeView('add')">
                <Icon type="android-add-circle"></Icon> 发送消息
              </Menu-item>
              <Menu-item name="sent" @click="changeView('sent')">
                <Icon type="android-send"></Icon> 已发消息
              </Menu-item>
            </Menu-group>
        </Menu>
        </div>
      </Col>
      <Col span="18">
        <component v-bind:is="currentView" @changeView="changeView"></component>
      </Col>
    </Row>

</div>
</template>

<script>
import NewMessage from '@/components/message/NewMessage'
import ReadMessage from '@/components/message/ReadMessage'
import SentMessage from '@/components/message/SentMessage'
import DeleteMessage from '@/components/message/DeleteMessage'
import AddMessage from '@/components/message/AddMessage'

export default {
  name: 'message',
  data: function () {
    return {
      currentView: 'new'
    }
  },
  components: {
    new: NewMessage,
    read: ReadMessage,
    sent: SentMessage,
    delete: DeleteMessage,
    add: AddMessage
  },
  methods: {
    changeView: function (name) {
      this.currentView = name
    }
  }
}
</script>
